<template>
  <div>
    <Head title="Pedidos" />
    <h1 class="mb-8 text-3xl font-bold">Pedidos</h1>
    <div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-6">
        <!-- Card de Ventas Totales -->
        <div class="bg-white p-6 rounded-lg shadow-lg">
        <div>
            <form @submit.prevent="filterByDate">
            <!-- Cambiar a grid para hacer que sea responsive -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                <div>
                <label for="date_start" class="block text-sm font-medium text-gray-700">Fecha Inicio</label>
                <text-input type="date" id="date_start" v-model="form.date_start" class="mt-1 block w-full" />
                </div>
                <div>
                <label for="date_end" class="block text-sm font-medium text-gray-700">Fecha Fin</label>
                <text-input type="date" id="date_end" v-model="form.date_end" class="mt-1 block w-full" />
                </div>
                <div class="flex items-end">
                <button type="submit"
                    class="text-white bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center w-full">
                    Filtrar
                </button>
                </div>
            </div>
            </form>
        </div>
        
        <!-- <p class="text-sm text-gray-500 mt-2">Total de ventas del {{ formatDate(dateStart) }} al {{ formatDate(dateEnd) }}</p> -->
        </div>
        <!-- Card de Reporte -->
        <div class="bg-white p-6 rounded-lg shadow-lg">
        <h2 class="text-xl font-bold mb-2 text-gray-800">Reporte por día</h2>
        
        <div class=" flex items-center my-2">
            <text-input v-model="order_date" type="date" id="order_date" :max="maxDate" class="mr-2" />            
            <!-- <button @click="descargarPDF()"
            class="px-4 py-3.5 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300">
            Imprimir Reporte
            </button> -->
            <Link class="flex items-center px-2 py-4" :href="`/orders/report/employee/${order_date}/${form.employee_id}`">
              <button class="px-4 py-3.5 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300">
                  Generar Reporte
              </button>
            </Link>
            <!-- <Link class="flex items-center px-2 py-4" :href="`/orders/report-by-product/${order_date}`">
            <button class="px-4 py-3.5 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-300">
                Reporte de productos
            </button>
            </Link> -->
        </div>
        <!-- <p class="text-sm text-gray-500 mt-2">Total de ventas del {{ currentDate }}</p> -->
        </div>
    </div>
    </div>
  
    <!-- Tabla dinámica de órdenes -->
    <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-2">Id</th>
            <th class="pb-4 pt-6 px-2">Ruta</th>
            <th class="pb-4 pt-6 px-2">Tienda</th>
            <th class="pb-4 pt-6 px-2">Desc</th>
            <th class="pb-4 pt-6 px-2">Total</th>
            <th class="pb-4 pt-6 px-2">Fecha</th>
        </tr>
        <tr v-for="order in employeeOrders" :key="order.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer" @click="showOrderDetails(order.id)">
            <td class="border-t px-6 py-4">{{ order.id }}</td>
            <td class="border-t px-6 py-4">{{ order.name_route }}</td>
            <td class="border-t px-6 py-4">{{ order.name_store }}</td>
            <td class="border-t px-6 py-4">{{ order.details_visit }}</td>
            <td class="border-t px-6 py-4">${{ order.total_amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) }}</td>
            <td class="border-t px-6 py-4">{{ formatDate(order.date_order) }}</td>
        </tr>
        <tr v-if="employeeOrders.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">No se encontraron pedidos para este preventista.</td>
        </tr>
        </table>
    </div>      
    <div>
    <DialogInput v-if="showDialogDetails" label="Detalles" :title="'Detalles del Pedido'"
        @close="showDialogDetails = false">
        <div class="mt-2 px-2 py-3">
        <p class="text-sm text-gray-500">
            Tienda: {{ selectedOrderDetails.nameStore }}<br>
            Encargado: {{ selectedOrderDetails.inCharge }}<br>
            Fecha: {{ formatDate(selectedOrderDetails.order_date) }} <br>
        </p>
        <p class="text-base">Detalles de visita: {{ selectedOrderDetails.details_visit || 'Sin detalles' }}</p>
        <table class="mt-4 w-full text-sm">
            <thead>
            <tr class="text-left font-bold">
                <th class="py-2 px-4">Producto</th>
                <th class="py-2 px-4">Unidad</th>
                <th class="py-2 px-4">Precio</th>
                <th class="py-2 px-4">Cantidad</th>
                <th class="py-2 px-4">Total</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="detail in selectedOrderDetails.details" :key="detail.id">
                <td class="border-t py-2 px-4">{{ detail.name_product }}</td>
                <td class="border-t py-2 px-4">{{ detail.product_unit }}</td>
                <td class="border-t py-2 px-4">${{ detail.price.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) }}</td>
                <td class="border-t py-2 px-4">{{ detail.amount }}</td>
                <td class="border-t py-2 px-4">${{ (detail.amount * detail.price).toLocaleString('en-US', {
                minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
            </tr>
            </tbody>
        </table>
        </div>
    </DialogInput>
    </div>
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import DialogInput from '@/Shared/Dialog'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    Link,
    Icon,
    DialogInput,
    TextInput
  },
  layout: Layout,
  props: {
    dateStart: String,
    dateEnd: String,
    startDate: String,
    endDate: String,
    filters: Object,
    employeeOrders: Array,
    orderDetails: Object,
  },
  data() {
    return {
      form: {
        date_start: this.filters.date_start || this.dateStart,
        date_end: this.filters.date_end || this.dateEnd,
        employee_id: this.filters.employee_id,
      },
      selectedEmployee: null,
      showDialogDetails: false,
      selectedOrderDetails: null,
      currentDate: new Date().toLocaleDateString(),
      order_date: ''
    }
  },
  methods: {
    formatDate(originalDate) {
      const formattedDate = new Date(originalDate)
      const opciones = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }
      return formattedDate.toLocaleString('es-ES', opciones);
    },
    filterByDate() {
      this.$inertia.get('/orders/employee', this.form);
    },
    showOrderDetails(orderId) {
    const order = this.employeeOrders.find(o => o.id === orderId);
    if (order) {
        this.selectedOrderDetails = {
        ...this.orderDetails[orderId],
        details_visit: order.details_visit
        };
        this.showDialogDetails = true;
    }
    },
    descargarPDF() {
        // window.location.href = '/generar-pdf';  
        window.location.href = `/generar-pdf/${this.order_date}`;      
    },
},
computed: {
    maxDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Meses de 0-11
    const day = String(today.getDate()).padStart(2, '0'); // Días de 1-31
    return `${year}-${month}-${day}`;
    },
},
created() {
    this.order_date = this.maxDate;
},
}
</script>